// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Dd7C","select":"styles_select__3V5Sz"};